import { render } from "./WebQrScan.vue?vue&type=template&id=8c8e0534"
import script from "./WebQrScan.vue?vue&type=script&lang=js"
export * from "./WebQrScan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__